import React from "react";
import WujieReact from "wujie-react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import hostMap from "../../hostMap";
import { loginInfo } from "../../utils";

export default function WdwScreenV3CampusPage() {
  const navigate = useNavigate();
  const { tenantId, staId } = useSelector(state => state.user);
  const childUrl = hostMap("//localhost:9020/");

  const props = {
    token: localStorage.getItem("saas-token"),
    tenantId,
    stationId: staId,
    menuType: 1,
    jump: name => navigate(`/${name}`),
    method: { loginInfo }
  };

  return (
    <WujieReact
      width="100%"
      height="100%"
      name="screen-v3-campus"
      url={childUrl}
      sync={false}
      props={props}
      degrade={true}
    />
  );
}
